import React, { useState } from 'react'; // Import useState
import { motion } from 'framer-motion';
import LogoImage from '../assets/Logo.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // State to manage mobile menu visibility

  const navVariants = {
    hidden: { y: -100, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.7, ease: "easeIn" } },
  };

  const linkVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  const mobileMenuVariants = {
    hidden: { opacity: 0, x: "100%" },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  return (
    <motion.nav
      className="fixed top-0 left-0 w-full bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 shadow-md z-50"
      variants={navVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">
        <motion.div className="flex items-center space-x-2" variants={linkVariants}>
          <img src={LogoImage} alt="A3 Creative Hub Logo" className="h-10 w-auto" />
        </motion.div>

        {/* Desktop Navigation Links */}
        <div className="hidden md:flex space-x-6"> {/* Hidden on small screens, visible on medium and up */}
          <motion.a href="#hero" className="hover:text-pink-500 font-bold transition" variants={linkVariants} whileHover={{ scale: 1.1 }}>Home</motion.a>
          <motion.a href="#products" className="hover:text-pink-500 font-bold transition" variants={linkVariants} whileHover={{ scale: 1.1 }}>Products</motion.a>
          <motion.a href="#gallery" className="hover:text-pink-500 font-bold transition" variants={linkVariants} whileHover={{ scale: 1.1 }}>Gallery</motion.a>
          <motion.a href="#reviews" className="hover:text-pink-500 font-bold transition" variants={linkVariants} whileHover={{ scale: 1.1 }}>Customer Reviews</motion.a>
          <motion.a href="#contact" className="hover:text-pink-500 font-bold transition" variants={linkVariants} whileHover={{ scale: 1.1 }}>Contact</motion.a>
          <motion.a href="#about" className="hover:text-pink-500 font-bold transition" variants={linkVariants} whileHover={{ scale: 1.1 }}>About Us</motion.a>
        </div>

        {/* Mobile Menu Button (Hamburger) */}
        <div className="md:hidden flex items-center"> {/* Visible on small screens, hidden on medium and up */}
          <button onClick={() => setIsOpen(!isOpen)} className="text-gray-800 focus:outline-none">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu (Conditionally rendered) */}
      {isOpen && (
        <motion.div
          className="md:hidden bg-gradient-to-r from-pink-200 via-yellow-100 to-pink-100 px-4 pt-2 pb-4 space-y-2 text-center"
          variants={mobileMenuVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.a href="#hero" className="block hover:text-pink-500 font-bold transition py-2" onClick={() => setIsOpen(false)} variants={linkVariants}>Home</motion.a>
          <motion.a href="#products" className="block hover:text-pink-500 font-bold transition py-2" onClick={() => setIsOpen(false)} variants={linkVariants}>Products</motion.a>
          <motion.a href="#gallery" className="block hover:text-pink-500 font-bold transition py-2" onClick={() => setIsOpen(false)} variants={linkVariants}>Gallery</motion.a>
          <motion.a href="#reviews" className="block hover:text-pink-500 font-bold transition py-2" onClick={() => setIsOpen(false)} variants={linkVariants}>Customer Reviews</motion.a>
          <motion.a href="#contact" className="block hover:text-pink-500 font-bold transition py-2" onClick={() => setIsOpen(false)} variants={linkVariants}>Contact</motion.a>
          <motion.a href="#about" className="block hover:text-pink-500 font-bold transition py-2" onClick={() => setIsOpen(false)} variants={linkVariants}>About Us</motion.a>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar; 